// MISBEHAV_D — Cart drawer overlay.
// Watches the theme's own <theme-drawer id="cart-drawer"> element (present
// site-wide, rendered once in layout/theme.liquid) and shows/hides a
// full-page dimming overlay whenever its `open` attribute is added/removed —
// regardless of what opened it (the header cart icon, the product page's
// own Add to Cart buttons, etc). Clicking the dimmed overlay closes the
// drawer, matching the native modal-backdrop behavior this theme already
// has below 990px.
//
// IMPORTANT: this used to attach a MutationObserver directly to the
// #cart-drawer element found at load time. That broke the overlay (it
// stopped appearing at all) as soon as the product page's Add to Cart
// button ran, because that flow replaces the ENTIRE cart-drawer section's
// markup with `wrapper.outerHTML = <fresh html>` to show the newly added
// item — which swaps in a brand new <theme-drawer id="cart-drawer"> DOM
// node. A MutationObserver only ever reports on the exact node it was
// given, so once that original node was replaced (detached from the page),
// the observer kept "watching" a dead node forever and never fired again
// for the rest of that page view. The fix is to observe something that is
// NEVER replaced — document.body — with subtree:true, and look up
// #cart-drawer fresh every single time, instead of holding onto one
// reference. This survives the section being swapped out any number of
// times.
(function () {
  function ensureOverlay() {
    var overlay = document.getElementById('misb-cart-overlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'misb-cart-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    // Clicking the dimmed area closes the drawer, same as clicking outside
    // it would in native modal mode. Looked up fresh at click time, so this
    // keeps working even if the drawer element has since been replaced.
    overlay.addEventListener('click', function () {
      var drawer = document.querySelector('#cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  function sync() {
    var overlay = ensureOverlay();
    var drawer = document.querySelector('#cart-drawer');

    if (drawer && drawer.hasAttribute('open')) {
      overlay.classList.add('is-visible');
    } else {
      overlay.classList.remove('is-visible');
    }
  }

  function start() {
    sync(); // covers the drawer already being open on load (e.g. restored state)

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'open') {
          sync();
          break;
        }
      }
    });

    // subtree:true on document.body (which this theme never replaces or
    // removes) instead of on #cart-drawer itself — see the top-of-file
    // comment for why.
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
